
import { QuizData, ElementType } from './types';
import { generatePageUniqueId } from './src/utils/helpers';

// This data now serves as the initial state for the Quiz Creator.
// It will be overwritten by the code you generate in the app.
export const QUIZ_DATA: QuizData = {
  name: 'Meu Quiz',
  config: {
    colors: {
      background: '#ffffff',
      primary: '#000000',
    },
    fontSizes: {
      title: '1.7rem',
      subtitle: '0.9rem',
      option: '1rem',
    },
    fontFamily: 'Inter',
    contentAlignment: 'center',
    header: {
      showBackButton: true,
      showStepIndicator: true,
      progressBarStyle: 'default',
    },
    gamification: {
      coinsEnabled: false,
      coinsPreText: 'Seu Saldo: ',
      coinsPostText: 'ptos',
    },
    validation: {
      requiredMessage: 'Preencha os campos obrigatórios antes de continuar.',
    },
    scripts: {
      head: '',
      footer: '',
    },
  },
  pages: [
    {
      id: 0,
      uniqueId: generatePageUniqueId(),
      title: "Etapa 01",
      elements: [
        {
          id: 'el_title_1',
          type: ElementType.Title,
          content: 'Bem-vindo ao Quiz!',
          align: 'center'
        },
        {
          id: 'el_opts_1',
          type: ElementType.Options,
          title: 'Escolha uma opção:',
          options: [
            { id: 'opt1', text: 'Opção 1', mediaType: 'none' },
            { id: 'opt2', text: 'Opção 2', mediaType: 'none' },
            { id: 'opt3', text: 'Opção 3', mediaType: 'none' },
            { id: 'opt4', text: 'Opção 4', mediaType: 'none' },
          ],
          layout: 'grid2',
          style: 'simple',
          checkStyle: 'traditional',
          border: 'medium',
        } as any,
      ],
    },
    {
      id: 1,
      uniqueId: generatePageUniqueId(),
      title: "Etapa 02",
      elements: [
        {
          id: 'el_opts_2',
          type: ElementType.Options,
          title: 'Qual sua preferência?',
          description: 'Selecione a melhor opção para você.',
          options: [
            { id: 'opt5', text: 'Melhor escolha possível', mediaType: 'none' },
            { id: 'opt6', text: 'Pode ser útil', mediaType: 'none' },
            { id: 'opt7', text: 'Não tenho certeza', mediaType: 'none' },
            { id: 'opt8', text: 'Prefiro outra opção', mediaType: 'none' },
          ],
          layout: 'grid2',
          style: 'simple',
          checkStyle: 'traditional',
          border: 'medium',
        } as any,
      ],
    },
    {
      id: 2,
      uniqueId: generatePageUniqueId(),
      title: "Etapa 03",
      elements: [
        {
          id: 'el_opts_3',
          type: ElementType.Options,
          title: 'Selecione todas que se aplicam:',
          multiple: true,
          options: [
            { id: 'opt9', text: 'Opção A', mediaType: 'none' },
            { id: 'opt10', text: 'Opção B', mediaType: 'none' },
            { id: 'opt11', text: 'Opção C', mediaType: 'none' },
            { id: 'opt12', text: 'Opção D', mediaType: 'none' },
          ],
          layout: 'grid2',
          style: 'simple',
          checkStyle: 'traditional',
          border: 'medium',
        } as any,
        {
          id: 'el_btn_3',
          type: ElementType.Button,
          text: 'FINALIZAR',
          action: 'next',
          height: 'medium',
          styleVariant: 'alto',
        } as any,
      ],
    },
  ]
};
